var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramLogo = function SvgTelegramLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.32 16.983c.268.19.614.237.922.12a.97.97 0 0 0 .604-.7C17.57 13 19.326 4.387 19.986 1.29a.65.65 0 0 0-.217-.632.67.67 0 0 0-.664-.116C15.611 1.835 4.85 5.872.452 7.5A.69.69 0 0 0 0 8.166a.69.69 0 0 0 .494.637c1.973.59 4.562 1.41 4.562 1.41s1.21 3.655 1.84 5.513a.73.73 0 0 0 .503.48.72.72 0 0 0 .676-.172l2.58-2.436s2.977 2.182 4.665 3.385M6.145 9.752l1.4 4.615.31-2.923 8.488-7.655a.23.23 0 0 0 .027-.314.237.237 0 0 0-.313-.053z",
    clipRule: "evenodd"
  })));
};
export default SvgTelegramLogo;